import _ from "lodash";
import client from "lib/apolloClient/client";
import { setToastMsg } from "Login/modules/LoginModule";
import {
  initiateTemporalWorkflowMutation,
  retryTemporalWorkflowMutation,
} from "../WorkflowsMutations";

// Thunks

export const initiateTemporalWorkflow = ({
  entityIds,
  entityType,
  jobId,
  orgIds,
  refetchQueries,
  showToastMsg = true,
}) => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: initiateTemporalWorkflowMutation,
        variables: {
          input: {
            entityIds,
            entityType,
            ...(jobId ? { jobId } : {}),
            orgIds,
          },
        },
        awaitRefetchQueries: true,
        refetchQueries,
      });

      const mutationResponse = _.get(
        res,
        "data.integration.initiateTemporalWorkflow",
        {}
      );

      const { isSuccess = false, message = "" } = mutationResponse;
      if (showToastMsg) {
        if (isSuccess) {
          dispatch(
            setToastMsg({
              type: "success",
              msg: "toastMsgs:workflow_initiated_successfully",
            })
          );
        } else {
          dispatch(setToastMsg(message || "toastMsgs:something_went_wrong"));
        }
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const retryTemporalWorkflow = ({ variables, refetchQueries = [] }) => {
  return async dispatch => {
    try {
      const res = await client.mutate({
        mutation: retryTemporalWorkflowMutation,
        variables,
        awaitRefetchQueries: true,
        refetchQueries,
      });

      const mutationResponse = _.get(
        res,
        "data.integration.retryTemporalWorkflow",
        {}
      );

      const { isSuccess = false, message = "" } = mutationResponse;

      if (mutationResponse) {
        dispatch(
          setToastMsg({
            type: isSuccess ? "success" : "error",
            msg: message,
          })
        );
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};
